export default "__VITE_ASSET__Bh2Z73ly__"